import React from "react";

const Ad = () => {
  return (
    <div>
      This would be an ad builder - no design changes at this time. Hype page
      with trackers remains same as well
    </div>
  );
};

export default Ad;
